var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-find"},[_vm._m(0),_c('el-button',{staticClass:"btn",attrs:{"type":"text"},on:{"click":function($event){return _vm.$router.push({name:'work.index.homeIndex'})}}},[_vm._v("返回首页 ")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc"},[_c('p',[_vm._v("404~")]),_c('p',[_vm._v("您要找的页面不见了~")])])
}]

export { render, staticRenderFns }